import { Link } from "react-router-dom";
import Logo from "../components/Logo";

export default function Footer() {
  return (
    <footer className="border-t border-navy/10 bg-white">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-7 px-5 py-12 sm:px-8">
        <Logo className="h-7" />
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-2">
          <Link to="/impressum" data-testid="footer-impressum" className="text-xs font-semibold uppercase tracking-[0.2em] text-textgrau transition-colors hover:text-textdunkel">
            Impressum
          </Link>
          <Link to="/datenschutz" data-testid="footer-datenschutz" className="text-xs font-semibold uppercase tracking-[0.2em] text-textgrau transition-colors hover:text-textdunkel">
            Datenschutz
          </Link>
          <button
            type="button"
            data-testid="footer-cookieeinstellungen"
            onClick={() => {
              try {
                localStorage.removeItem("2bs_consent");
              } catch (e) {
                /* kein Speicherzugriff */
              }
              window.dispatchEvent(new CustomEvent("2bs-cookieeinstellungen"));
            }}
            className="text-xs font-semibold uppercase tracking-[0.2em] text-textgrau transition-colors hover:text-textdunkel"
          >
            Cookie-Einstellungen
          </button>
        </div>
      </div>
    </footer>
  );
}
